/*=========================================================================================
	File Name: moduleAuthActions.js
	Description: Auth Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import user from "../../../public/user.json";
import axios from "axios";
import router from "../../router"
import store from "../store";
import i18n from "../../i18n/i18n";
export default {
	isTokenActive({ commit, state, dispatch }, payload) {
		var sistemAddress = user.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		try {
			return new Promise((resolve, reject) => {
				axios.get(sistemAddress + "api/UzumService/tokenactive", {
					headers: {
						Authorization: `Bearer ${token}`,
					}
				}).then(response => {
					if (response.status == 200) {
						resolve(response);
					} else if (response.status == 401) {
						router.push("/login")
					}
				}).catch(err => {
					if (err) {
						router.push("/login")
					}
					resolve(err);
				});;
			});
		} catch (error) {
			console.log(error)
		}

	},

	getData({ commit, state, dispatch }) {
		return new Promise((resolve, reject) => {
			try {
				dispatch("isTokenActive").then(response => {
					if (response.toString().includes("Error")) { }
					else { 

						//list all marketplace name
						store.dispatch("order/listMarketplaceName").then(response => { 
							if (response) {  
								console.log(response)
								if (response.status == 200) {
								} else
									console.log(response)
							}
						}).catch(err => {
							console.log(err)
						});
						//list all paymnet type
						store.dispatch("customer/listPaymentType").then(response => { 
							if (response) { 
								if (response.status == 200) {
								} else
									console.log(response)
							}
						}).catch(err => {
							console.log(err)
						});
						//list all customers
						store.dispatch("customer/listCustomer").then(response => {
							if (response) {
								if (response.success == true) {
								} else
									console.log(response)
							}
						}).catch(err => {
							console.log(err)
						});
						//list all users
						store.dispatch("user/listUser").then(response => {
							if (response)
								if (response.success == true) {
								} else
									console.log(response)
						});
						//list all role
						store.dispatch("role/listRole").then(response => {
							if (response)
								if (response.success == true) {
								} else
									console.log(response)
						});
						//list all role list for depot
						store.dispatch("storehouse/listStorehouseForRole").then(response => {
							if (response)
								if (response.success == true) {
								} else
									console.log(response)
						});
						//list all stock tracking (pallets) for role
						store.dispatch("stockTracking/listStockTrackingForRole").then(response => {
							if (response)
								if (response.success == true) {
								} else
									console.log(response)
						});
						//list all stock for role
						store.dispatch("stock/listStockForRole").then(response => {
							if (response)
								if (response.success == true) {

								} else
									console.log(response)
						});
						//list all stock tracking (pallets)
						store.dispatch("stockTracking/listStocktrackingType").then(response => {
							if (response)
								if (response.success == true) {
								} else
									console.log(response)
						});
					}
				})


				resolve(true)
			} catch (error) {
				resolve(false)
			}

		})

	},

	login({ commit, state, dispatch }, payload) {
		const data = []
		var sistemAddress = user.userService;
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/UzumService/login", payload.userDetails)
				.then(response => {
					try {
						let tokenDeger = response.data.token;

						var base64Url = tokenDeger.split('.')[1];
						var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
						var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
							return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
						}).join(''));
						let rolDeger = JSON.parse(jsonPayload)
						// return JSON.parse(jsonPayload);
						data["ROLE"] = rolDeger["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]
						data['servisAdresi'] = user.userService
						data['fullFilmentTokenId'] = tokenDeger;
						data["userCode"] = rolDeger.code;
						data["userName"] = rolDeger.name;
						data["expiration"] = response.data.expiration;
						data["userId"] = response.data.user;
						data["companyid"] = rolDeger.companyid;

						let jsondata = {
							ROLE: rolDeger["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"],
							servisAdresi: user.userService,
							fullFilmentTokenId: tokenDeger,
							userCode: rolDeger.code,
							userName: rolDeger.name,
							expiration: response.data.expiration,
							userId: response.data.user,
							companyid: rolDeger.companyid
						}
						localStorage.setItem('ROLE', rolDeger["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"])
						localStorage.setItem('servisAdresi', user.userService)
						localStorage.setItem('fullFilmentTokenId', tokenDeger)
						localStorage.setItem('userCode', rolDeger.code)
						localStorage.setItem('userName', rolDeger.name)
						localStorage.setItem('expiration', response.data.expiration)
						localStorage.setItem('userId', response.data.user)
						localStorage.setItem('userInfoAuth', JSON.stringify(jsondata))
						localStorage.setItem('userLanguage', i18n.locale)
						localStorage.setItem('companyid', rolDeger.companyid)

						commit('setToken', data)
						store.commit('UPDATE_USER_INFO', data)
						dispatch("getData");


						resolve(response);
					} catch (error) {
						console.log(error)
					}

				})
				.catch(err => { 
					resolve(err.response);
				});
		});
		// Try to sigin

	},
	logout({ commit, state, dispatch },) {
		const data = []
		data["ROLE"] = ""
		data['servisAdresi'] = ""
		data['fullFilmentTokenId'] = "";
		data["userCode"] = "";
		data["userName"] = "";
		data["expiration"] = "";
		data["userId"] = "";
		data["userInfoAuth"] = ""

		localStorage.setItem('ROLE', "")
		localStorage.setItem('servisAdresi', "")
		localStorage.setItem('fullFilmentTokenId', "")
		localStorage.setItem('userCode', "")
		localStorage.setItem('userName', "")
		localStorage.setItem('expiration', "")
		localStorage.setItem('userId', "")
		localStorage.setItem('userInfoAuth', "")
		store.stock.Stock = [];

		commit('setToken', data)
	}
}
